import React, { useMemo, useRef, useState, useEffect } from 'react'
import * as THREE from 'three'
import { Canvas, useFrame, useThree } from 'react-three-fiber'
import './styles.scss'
import { NoiseEffect } from 'components/noiseEffect'
import { useSpring, animated } from 'react-spring/three'
// import { useWheel } from 'react-use-gesture'
const isMobile = window.innerWidth < 800

const BackgroundColor = ({ color }) => {
  const { gl } = useThree()

  const r = useRef(0)
  const g = useRef(0)
  const b = useRef(0)

  useEffect(() => {
    r.current = color[0]
    g.current = color[1]
    b.current = color[2]
  }, [])

  useFrame(() => {
    r.current += Math.round((color[0] - r.current) * 0.05)
    g.current += Math.round((color[1] - g.current) * 0.05)
    b.current += Math.round((color[2] - b.current) * 0.05)

    gl.setClearColor(`rgb(${r.current}, ${g.current}, ${b.current})`)
  })

  return null
}

const Rig = ({ mouse, autoMove }) => {
  const { camera } = useThree()
  const { gl } = useThree()

  gl.setClearColor('red')

  console.log('RIG')

  useFrame(state => {
    let x
    let z = 0

    if (autoMove) {
      x = Math.cos(state.clock.getElapsedTime() * 1) * 100
      z = Math.sin(state.clock.getElapsedTime() * 1) * 100
      // camera.position.x += (x - camera.position.x) * 0.05
      // camera.position.z += (z - camera.position.z) * 0.05
    } else {
      x = 0
      z = isMobile ? 20 : 10
    }

    camera.position.x += (mouse.current[0] / 100 - camera.position.x) * 0.05
    camera.position.y += (-mouse.current[1] / 100 - camera.position.y) * 0.05

    camera.lookAt(0, 0, 0)
  })

  return null
}

const Newspaper = React.memo(
  ({
    image,
    _origin = { position: [0, 0, 0], rotation: [0, 0, 0] },
    _target = { position: [0, 0, 0], rotation: [0, 0, 0] },
    size = [2, 3, 32, 32],
    _isFlying = false,
    isSelected = false
  }) => {
    console.log('RERENDER Newspaper')
    const [isFlying, setIsFlying] = useState(true)
    const [origin, setOrigin] = useState(_origin)
    const [target, setTarget] = useState(_target)
    const [seed, setSeed] = useState(0)
    const position = useMemo(() => origin.position, [])
    const rotation = useMemo(() => origin.rotation, [])
    const windStrengthMax = 2
    const { windValue } = useSpring({
      windValue: isFlying ? windStrengthMax : 0.25,
      config: { duration: 1000 }
    })
    /* const { animatedPosition } = useSpring({
    animatedPosition: target,
    config: { duration: 1000 }
  }) */
    const flagShaderMaterial = useRef(null)
    const mesh = useRef(null)
    const texture = useMemo(() => new THREE.TextureLoader().load(image), [])

    // const [target, setTarget] = useState(new THREE.Vector3(0, 0, 0))

    const flagShader = {
      uniforms: {
        wind: {
          type: 'f',
          value: 0.0
        },
        seed: {
          type: 'f',
          value: 0.0
        },
        image: {
          type: 't',
          value: ''
        },
        time: {
          type: 'f',
          value: 0.0
        }
      },
      fragmentShader: `
      uniform sampler2D image;
      varying vec2 vUv;
      
      void main(){
        gl_FragColor = texture2D(image, vUv);
      }
    `,
      vertexShader: `
      varying vec2 vUv;
      uniform float time;
      uniform float wind;
      uniform float seed;
  
      void main() {
        vUv = uv;
        float waveX1 = sin((position.x * 2.0 * seed + time * 5.0 * seed) * seed) * 0.05 * wind;
        float waveX2 = sin((position.x * 6.0 * seed + time * 5.0 * seed) * seed) * 0.075 * wind;
        float waveY1 = sin((position.y * 6.0 * seed + time * 5.0 * seed) * seed) * 0.045 * wind;
        float waveY2 = sin((position.y * 2.0 * seed + time * 2.0 * seed) * seed) * 0.15 * wind;
  
        vec3 newPosition = position + normal * vec3(1, 1, waveX1 + waveX2 + waveY1 + waveY2);
  
        gl_Position = projectionMatrix 
          * modelViewMatrix 
          * vec4(newPosition, 1.0);
      }
    `
    }

    useEffect(() => {
      setIsFlying(_isFlying)
    }, [_isFlying])

    useEffect(() => {
      setTarget(_target)
    }, [_target])

    useEffect(() => {
      setOrigin(_origin)
    }, [_origin])

    useEffect(() => {
      setSeed(1 + (0.5 - Math.random()) * 0.25)
    }, [])

    useFrame(state => {
      if (isSelected) {
        mesh.current.position.y += (6 - mesh.current.position.y) * 0.085
      } else {
        mesh.current.position.x +=
          (target.position[0] - mesh.current.position.x) * 0.05
        mesh.current.position.y +=
          (target.position[1] - mesh.current.position.y) * 0.05
        mesh.current.position.z +=
          (target.position[2] - mesh.current.position.z) * 0.05

        mesh.current.rotation.x +=
          (target.rotation[0] - mesh.current.rotation.x) * 0.05
        mesh.current.rotation.y +=
          (target.rotation[1] - mesh.current.rotation.y) * 0.05
        mesh.current.rotation.z +=
          (target.rotation[2] - mesh.current.rotation.z) * 0.05
      }

      // mesh.current.position.distanceTo(target.position)

      if (
        Math.abs(target.position[0] - mesh.current.position.x) < 0.25 &&
        isFlying
      ) {
        setIsFlying(false)
      } else if (
        Math.abs(target.position[0] - mesh.current.position.x) > 0.25 &&
        !isFlying
      ) {
        setIsFlying(true)
      }

      // mesh.current.rotateX(160)

      /* const head = new THREE.Vector3(target[0], target[1], target[2])
    head.multiplyScalar(2)
    head.add(mesh.current.position)
    mesh.current.lookAt(head)
    mesh.current.rotateX(THREE.Math.degToRad(90))
    mesh.current.rotateY(THREE.Math.degToRad(90)) */

      // mesh.current.position.x = Math.sin(state.clock.getElapsedTime())
      /*
    if (!mesh.current) return 0

    if (!isSelected) {
      const desired = target.sub(mesh.current.position)
      desired.normalize()
      desired.multiplyScalar(maxSpeed)
      const steer = desired.sub(velocity.current)
      steer.normalize().multiplyScalar(maxForce)
      acceleration.current.add(steer)
    } else {
      const desired = target.sub(mesh.current.position)
      desired.normalize()
      desired.multiplyScalar(maxSpeed)
      const steer = desired.sub(velocity.current)
      steer.normalize().multiplyScalar(maxForce)
      acceleration.current.add(steer)
    }

    velocity.current.add(acceleration.current)
    velocity.current.normalize().multiplyScalar(maxSpeed)
    //mesh.current.position.add(velocity.current)
    acceleration.current.multiplyScalar(0)

    const head = velocity.current.clone()
    //head.multiplyScalar(2)
    head.add(mesh.current.position)
    //mesh.current.lookAt(head)
    //mesh.current.rotateX(THREE.Math.degToRad(90))
    */

      flagShaderMaterial.current &&
        (flagShaderMaterial.current.uniforms.time.value = state.clock.getElapsedTime())
    })

    return (
      <animated.mesh ref={mesh} position={position} rotation={rotation}>
        <planeBufferGeometry attach='geometry' args={size} />
        <animated.shaderMaterial
          ref={flagShaderMaterial}
          attach='material'
          uniforms-wind-value={windValue}
          uniforms-image-value={texture}
          uniforms-seed-value={seed}
          args={[{ ...flagShader }]}
          side={THREE.DoubleSide}
        />
      </animated.mesh>
    )
  }
)

export const NewsPapers = ({ stage, selected, data }) => {
  const mouse = useRef([0, 0])
  const { backgroundColor } = useSpring({
    backgroundColor: stage > 0 ? 'black' : 'blue',
    config: { duration: 1000 },
    onFrame: val => {
      console.log(val)
    }
  })
  const [extraNewsPapers, setExtraNewsPapers] = useState(
    data.map((d, i) => ({
      id: d.id,
      image: d.image,
      selected: false,
      target: {
        position: [
          (1 - Math.round(Math.random()) * 2) * 10 + (5 - Math.random() * 10),
          10 - Math.random() * 20,
          -10 + (10 - Math.random() * 20)
        ],
        rotation: [
          THREE.Math.degToRad(Math.random() * 360),
          THREE.Math.degToRad(Math.random() * 360),
          THREE.Math.degToRad(Math.random() * 360)
        ]
      },
      origin: {
        position: [
          5 - Math.random() * 10,
          5 - Math.random() * 10,
          -i * (5 - Math.random() * 10)
        ],
        rotation: [
          THREE.Math.degToRad(Math.random() * 360),
          THREE.Math.degToRad(Math.random() * 360),
          THREE.Math.degToRad(Math.random() * 360)
        ]
      }
    }))
  )
  const [backgroundNewsPapers, setBackgroundNewsPapers] = useState(
    [...new Array(20)].map((a, i) => ({
      id: i,
      selected: false,
      target: {
        position: [
          200 - Math.random() * 400,
          30 - Math.random() * 60,
          -50 + (20 - Math.random() * 40)
        ],
        rotation: [
          THREE.Math.degToRad(Math.random() * 360),
          THREE.Math.degToRad(Math.random() * 360),
          THREE.Math.degToRad(Math.random() * 360)
        ]
      },
      origin: {
        position: [
          200 - Math.random() * 400,
          30 - Math.random() * 60,
          -100 + (50 - Math.random() * 100)
        ],
        rotation: [
          THREE.Math.degToRad(Math.random() * 360),
          THREE.Math.degToRad(Math.random() * 360),
          THREE.Math.degToRad(Math.random() * 360)
        ]
      }
    }))
  )
  const containerNode = useRef(null)

  useEffect(() => {
    console.log('> STAGE', stage)
    let n = [...extraNewsPapers]

    switch (stage) {
      case 0:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: n.origin
        }))
        break
      case 1:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 2:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2 - 2.2, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 3:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2 - 4.4, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 4:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2 - 6.6, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 5:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2 - 8.8, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 6:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2 - 11, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 7:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2 - 13.2, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 8:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2 - 15.4, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 9:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2 - 17.6, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 10:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2 - 19.8, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 11:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2 - 22, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 12:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2 - 24.2, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 13:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2 - 26.4, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 14:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2 - 28.6, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 15:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2 - 30.8, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 16:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [i * 2.2 - 33.0, 0, 0],
            rotation: [0, 0, 0]
          }
        }))
        break
      case 99:
        n = extraNewsPapers.map((n, i) => ({
          ...n,
          target: {
            position: [
              (1 - Math.round(Math.random()) * 2) * 20 +
                (20 - Math.random() * 40),
              (1 - Math.round(Math.random()) * 2) * 20 +
                (20 - Math.random() * 40),
              -50 + (20 - Math.random() * 40)
            ],
            rotation: [
              THREE.Math.degToRad(Math.random() * 360),
              THREE.Math.degToRad(Math.random() * 360),
              THREE.Math.degToRad(Math.random() * 360)
            ]
          }
        }))
        break
    }
    setExtraNewsPapers(n)
  }, [stage])

  useEffect(() => {
    console.log('Click on paper', selected, ': SELECTED')
    if (selected && selected <= extraNewsPapers.length) {
      console.log('Move the paper')
      const n = extraNewsPapers.map((n, i) => ({
        ...n,
        selected: false
      }))
      n.find(np => np.id === selected).selected = true
      // n[selected].selected = true
      setExtraNewsPapers(n)
    } else {
      const n = extraNewsPapers.map((n, i) => ({
        ...n,
        selected: false
      }))
      setExtraNewsPapers(n)
    }
  }, [selected])

  useEffect(() => {
    window.addEventListener('mousemove', e => {
      mouse.current = [
        e.clientX - window.innerWidth / 2,
        e.clientY - window.innerHeight / 2
      ]
    })
  }, [])

  console.log('RERENDER')

  return (
    <div className='three-fiber-container' ref={containerNode}>
      <Canvas
        colorManagement
        pixelRatio={window.devicePixelRatio}
        camera={{ position: [0, 0, isMobile ? 12 : 9], fov: 25 }}
      >
        <BackgroundColor color={(stage > 0 && stage < 99) ? [35, 30, 20] : [240, 240, 240]} />
        {extraNewsPapers.map((n, i) => (
          <Newspaper
            _isFlying
            key={n.id}
            _origin={n.origin}
            _target={n.target}
            isSelected={n.selected}
            image={require(`../../images/${n.image}`)}
          />
        ))}
        {/*backgroundNewsPapers.map((n, i) => (
          <Newspaper
            _isFlying
            key={i}
            _origin={n.origin}
            _target={n.target}
            isSelected={n.selected}
            image={require(`../../images/background/newspaper${Math.round(
              Math.random() * 3
            ) + 1}.jpg`)}
          />
            ))*/}
        <Rig mouse={mouse} autoMove={stage > 0} />
        <NoiseEffect />
      </Canvas>
    </div>
  )
}
